<template>
    <b-form @submit.prevent="openModalConfirm">
        <div class="form-parameter-wrapper">
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Bonus Bunga Didepan (Emas)" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input v-model="emasInput.BONUS_BUNGA_DIDEPAN_EMAS" id="persenHargaBonusBungaDidepanEmas" name="persenHargaBonusBungaDidepanEmas" step="0.01" @blur="roundPersen(1)" type="number" required></b-form-input>
                        </b-input-group>
                        <b-popover target="persenHargaBonusBungaDidepanEmas" title="Catatan" triggers="focus" placement="topleft">
                            <ul class="tooltip-content-wrapper list-popover-wrapper">
                                <li class="mb-2">
                                    <span class="small-muted-persen">Persentase berdasarkan Harga Barang.</span>
                                </li>
                                <li class="mb-2">
                                    <span class="small-muted-persen">
                                        Bila Harga Barang adalah 1.000.000 dan persentase 50%,
                                        maka pinjaman maksimal akan ditambahkan sebesar 500.000
                                    </span>
                                </li>
                            </ul>
                        </b-popover>
                        <span class="smallText text-muted">Persentase penambahan pinjaman maksimal untuk cabang yang memberlakukan skema Bunga Didepan.</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Harga Taksiran Emas" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input v-model="emasInput.HARGA_TAKSIRAN_EMAS" id="persenHargaTaksiranEmas" name="persenHargaTaksiranEmas" step="0.01" @blur="roundPersen(2)" type="number" required></b-form-input>
                        </b-input-group>
                        <b-popover target="persenHargaTaksiranEmas" title="Catatan" triggers="focus" placement="topleft">
                            <ul class="tooltip-content-wrapper list-popover-wrapper">
                                <li class="mb-2">
                                    <span class="small-muted-persen">Persentase berdasarkan Harga Barang.</span>
                                </li>
                                <li class="mb-2">
                                    <span class="small-muted-persen">
                                        Bila Harga Barang adalah 1.000.000 dan persentase 50%,
                                        maka pinjaman maksimal akan ditambahkan sebesar 500.000
                                    </span>
                                </li>
                            </ul>
                        </b-popover>
                        <span class="smallText text-muted">Persentase harga taksiran yang ditampilkan pada simulasi gadai.</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Pinjaman Minimal Emas" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input v-model="emasInput.PINJAMAN_MINIMAL_EMAS" id="persenPinjamanMinimalEmas" name="persenPinjamanMinimalEmas" step="0.01" @blur="roundPersen(3)" type="number" required></b-form-input>
                        </b-input-group>
                        <b-popover target="persenPinjamanMinimalEmas" title="Catatan" triggers="focus" placement="topleft">
                            <ul class="tooltip-content-wrapper list-popover-wrapper">
                                <li class="mb-2">
                                    <span class="small-muted-persen">Persentase berdasarkan Harga Barang.</span>
                                </li>
                                <li class="mb-2">
                                    <span class="small-muted-persen">
                                        Bila Harga Barang adalah 1.000.000 dan persentase 50%,
                                        maka pinjaman maksimal akan ditambahkan sebesar 500.000
                                    </span>
                                </li>
                            </ul>
                        </b-popover>
                        <span class="smallText text-muted">Persentase pinjaman minimal yang harus diajukan oleh anggota.</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Batas Bawah Gadai Emas" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input v-model="emasInput.BATAS_BAWAH_GADAI_EMAS" id="persenBatasBawahGadaiEmas" name="persenBatasBawahGadaiEmas" step="0.01" @blur="roundPersen(4)" type="number" required></b-form-input>
                        </b-input-group>
                        <b-popover target="persenBatasBawahGadaiEmas" title="Catatan" triggers="focus" placement="topleft">
                            <ul class="tooltip-content-wrapper list-popover-wrapper">
                                <li class="mb-2">
                                    <span class="small-muted-persen">Persentase berdasarkan Harga Barang.</span>
                                </li>
                                <li class="mb-2">
                                    <span class="small-muted-persen">
                                        Bila Harga Barang adalah 1.000.000 dan persentase 50%,
                                        maka pinjaman maksimal akan ditambahkan sebesar 500.000
                                    </span>
                                </li>
                            </ul>
                        </b-popover>
                        <span class="smallText text-muted">Persentase minimum / batas bawah pinjaman maksimal terhadap harga barang sebelum gadai ditolak.</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Nominal Batas Bawah Gadai Emas" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="emasInput.BATAS_BAWAH_GADAI_EMAS_NOMINAL" name="batasBawahGadaiEmasNominal" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Angka minimum pinjaman gadai. Gadai akan ditolak bila maksimum pinjaman yang didapatkan dibawah angka ini.</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Admin Emas" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input v-model="emasInput.ADM_EMAS" id="adminEmasPersen" name="adminEmas" step="0.01" @blur="roundPersen(5)" type="number" required></b-form-input>
                        </b-input-group>
                        <b-popover target="adminEmasPersen" title="Catatan" triggers="focus" placement="topleft">
                            <ul class="tooltip-content-wrapper list-popover-wrapper">
                                <li class="mb-2">
                                    Persentase berdasarkan pokok pinjaman.
                                </li>
                                <li class="mb-2">
                                    Bila input adalah 10%, maka artinya 10% dari pokok pinjaman.
                                </li>
                            </ul>
                        </b-popover>
                        <span class="smallText text-muted">Biaya admin yang dikenakan di awal dan perpanjangan gadai emas</span>
                    </b-col>
                    <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="emasInput.ADM_EMAS_MIN" name="minAdminEmas" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Minimum biaya admin</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Persentase Denda Emas" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input required v-model="emasInput.DENDA_EMAS" id="persenDendaEmas" name="persenDendaEmas" step="0.01" @blur="roundPersen(6)" type="number"></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Persentase denda per perpanjangan untuk keterlambatan gadai emas</span>
                    </b-col>
                </b-row>
                <b-popover target="persenDendaEmas" title="Catatan" triggers="focus" placement="topleft">
                    <ul class="tooltip-content-wrapper list-popover-wrapper">
                        <li class="mb-2">
                            Persentase berdasarkan pokok pinjaman.
                        </li>
                        <li class="mb-2">
                            Bila input adalah 10%, maka artinya 10% dari pokok pinjaman.
                        </li>
                    </ul>
                </b-popover>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Biaya Penalti Emas" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <!-- <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="emasInput.PENALTI_EMAS" name="biayaPenaltiEmas" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Biaya penalti yang dikenakan untuk pembayaran gadai emas yang sudah masuk dalam order lelang</span>
                    </b-col> -->
                    <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="emasInput.MIN_PENALTI_EMAS" name="biayaPenaltiEmas" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Minimum pinjaman yang dikenakan penalti emas, untuk pembayaran gadai emas yang sudah masuk dalam order lelang</span>
                    </b-col>
                    <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="emasInput.PENALTI_EMAS" name="biayaPenaltiEmas" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Penalti yang dikenakan untuk pembayaran gadai emas yang sudah masuk dalam order lelang</span>
                    </b-col>
                </b-row>
            </b-form-group>
            
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Baku Perusahaan" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-form-input v-model="emasInput.BAKU_PERUSAHAAN_EMAS" name="beratKering" min="0" max="99" step="0.01" type="number" @blur="roundPersen(7)" required></b-form-input>
                        <span class="smallText text-muted">Angka pengali untuk menghitung potongan berat batuan. Berat Baku Perusahaan x Ukuran Batu x Jumlah</span>
                    </b-col>
                </b-row>
            </b-form-group>

            <!-- <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Potongan Pengait Emas" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group append="%">
                            <b-form-input required v-model="emasInput.POTONGAN_PENGAIT_EMAS" id="potonganPengaitEmas" name="potonganPengaitEmas" step="0.01" @blur="roundPersen(8)" type="number"></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Persentase pemotongan dari berat kering emas</span>
                    </b-col>
                </b-row>
            </b-form-group> 

            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Potongan Karat Cap Tempelan" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group>
                            <b-form-input required v-model="emasInput.POTONGAN_KARAT_CAP_TEMPELAN" id="potonganKaratCapTempelan" name="potonganKaratCapTempelan" step="1" type="number"></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Potongan karat bila cap tempelan. Bila diisi 2, maka akan diturunkan sebesar 2 karat untuk perhitungan pinjaman.</span>
                    </b-col>
                </b-row>
            </b-form-group>-->

            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Maksimum Gadai Emas" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-form-input v-model="emasInput.MAX_GADAI_EMAS" name="maxGadaiEmas" type="number" required></b-form-input>
                        <span class="smallText text-muted">Jumlah maksimum gadai emas berjalan per anggota</span>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Bonus Gadai Pertama Emas" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="emasInput.BONUS_GADAI_PERTAMA_EMAS" name="bonusGadaiPertamaEmas" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Nominal tambahan yang diberikan untuk penggadaian pertama anggota</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Notifikasi Approval Emas KU" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="emasInput.NOTIF_KU_MIN_EMAS" name="notifKuMinEmas" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Minimum pinjaman pokok gadai yang akan mengirimkan notifikasi ke KU cabang</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Notifikasi Approval Emas KC" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="emasInput.NOTIF_KC_MIN_EMAS" name="notifKcMinEmas" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Minimum pinjaman pokok gadai yang akan mengirimkan notifikasi ke KC cabang</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Notifikasi Approval Emas AM" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="emasInput.NOTIF_KCS_MIN_EMAS" name="notifKcsMinEmas" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Minimum pinjaman pokok gadai yang akan mengirimkan notifikasi ke AM cabang</span>
                    </b-col>
                </b-row>
            </b-form-group>

            <b-form-group
                label-cols-sm="12"
                label-cols-lg="3"
                label="Notifikasi Approval Emas PUSAT" 
                label-align="left"
                >
                <b-row class="parameter-wrapper">
                    <b-col>
                        <b-input-group prepend="Rp">
                            <b-form-input v-model="emasInput.NOTIF_PUSAT_MIN_EMAS" name="notifKcsMinEmas" required></b-form-input>
                        </b-input-group>
                        <span class="smallText text-muted">Minimum pinjaman pokok gadai yang akan mengirimkan notifikasi ke PUSAT cabang</span>
                    </b-col>
                </b-row>
            </b-form-group>

        </div>
        <div class="form-wrapper-btn submit-btn-wrapper">
            <b-button type="submit" name="parameterUpdateBtn" variant="pgiBtn">Update</b-button>
        </div>
        <ModalConfirm id="modal-edit-emas" title="Confirm Edit Parameter Emas" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah parameter emas ini?" @submit="onSubmit" />
    </b-form>
</template>

<script>
export default {
    name: 'emas',
    props: {
        emasInput: { type: Object, required: true }
    },
    data(){
        return{
            isSubmitting: false,
            newData: {}
        }
    },
    watch: {
        "emasInput.BATAS_BAWAH_GADAI_EMAS_NOMINAL": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.emasInput.BATAS_BAWAH_GADAI_EMAS_NOMINAL = result);
        },
        "emasInput.ADM_EMAS_MIN": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.emasInput.ADM_EMAS_MIN = result);
        },
        "emasInput.PENALTI_EMAS": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.emasInput.PENALTI_EMAS = result);
        },
        "emasInput.MIN_PENALTI_EMAS": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.emasInput.MIN_PENALTI_EMAS = result);
        },
        "emasInput.BONUS_GADAI_PERTAMA_EMAS": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.emasInput.BONUS_GADAI_PERTAMA_EMAS = result);
        },
        "emasInput.NOTIF_KU_MIN_EMAS": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.emasInput.NOTIF_KU_MIN_EMAS = result);
        },
        "emasInput.NOTIF_KC_MIN_EMAS": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.emasInput.NOTIF_KC_MIN_EMAS = result);
        },
        "emasInput.NOTIF_KCS_MIN_EMAS": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.emasInput.NOTIF_KCS_MIN_EMAS = result);
        },
        "emasInput.NOTIF_PUSAT_MIN_EMAS": function(newValue) {
            const result = newValue.replace(/\D/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.emasInput.NOTIF_PUSAT_MIN_EMAS = result);
        },
    },
    methods: {
        //----------------- Fungsi Submit Data -----------------

        onSubmit() {
            this.newData = JSON.parse(JSON.stringify(this.emasInput))
            
            const batasBawahGadaiEmasNominal = this.$helper.removeThousandSeparator(this.newData.BATAS_BAWAH_GADAI_EMAS_NOMINAL);
            this.newData.BATAS_BAWAH_GADAI_EMAS_NOMINAL = batasBawahGadaiEmasNominal;
            const minAdminEmas = this.$helper.removeThousandSeparator(this.newData.ADM_EMAS_MIN);
            this.newData.ADM_EMAS_MIN = minAdminEmas;
            const biayaPenaltiEmas = this.$helper.removeThousandSeparator(this.newData.PENALTI_EMAS);
            this.newData.PENALTI_EMAS = biayaPenaltiEmas;
            const minBiayaPenaltiEmas = this.$helper.removeThousandSeparator(this.newData.MIN_PENALTI_EMAS);
            this.newData.MIN_PENALTI_EMAS = minBiayaPenaltiEmas;
            const bonusGadaiPertamaEmas = this.$helper.removeThousandSeparator(this.newData.BONUS_GADAI_PERTAMA_EMAS);
            this.newData.BONUS_GADAI_PERTAMA_EMAS = bonusGadaiPertamaEmas;
            const notifKuMinEmas = this.$helper.removeThousandSeparator(this.newData.NOTIF_KU_MIN_EMAS);
            this.newData.NOTIF_KU_MIN_EMAS = notifKuMinEmas;
            const notifKcMinEmas = this.$helper.removeThousandSeparator(this.newData.NOTIF_KC_MIN_EMAS);
            this.newData.NOTIF_KC_MIN_EMAS = notifKcMinEmas;
            const notifKcsMinEmas = this.$helper.removeThousandSeparator(this.newData.NOTIF_KCS_MIN_EMAS);
            this.newData.NOTIF_KCS_MIN_EMAS = notifKcsMinEmas;
            const notifPusatMinEmas = this.$helper.removeThousandSeparator(this.newData.NOTIF_PUSAT_MIN_EMAS);
            this.newData.NOTIF_PUSAT_MIN_EMAS = notifPusatMinEmas;
            
            let payload = new FormData()
            
            for (let [key, value] of Object.entries(this.newData)) {
                payload.append("name", key)
                payload.append("value", value)
            }

            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true
            
            this.$axios.post("parameter/update/", payload).then(response => {
                this.$helper.toastSucc(this, "Parameter Emas telah berhasil diubah!")
                this.$bvModal.hide("modal-edit-emas")
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },
        
        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------
        
        openModalConfirm(){
            this.$bvModal.show("modal-edit-emas")
        },

        roundPersen(id){
            if(id == 1){
                var persenBonusBungaDidepanEmas = Number(this.emasInput.BONUS_BUNGA_DIDEPAN_EMAS).toFixed(2);
                this.emasInput.BONUS_BUNGA_DIDEPAN_EMAS = persenBonusBungaDidepanEmas;
            }else if(id == 2){
                var persenHargaTaksiranEmas = Number(this.emasInput.HARGA_TAKSIRAN_EMAS).toFixed(2);
                this.emasInput.HARGA_TAKSIRAN_EMAS = persenHargaTaksiranEmas;
            }else if(id == 3){
                var persenPinjamanMinEmas = Number(this.emasInput.PINJAMAN_MINIMAL_EMAS).toFixed(2);
                this.emasInput.PINJAMAN_MINIMAL_EMAS = persenPinjamanMinEmas;
            }else if(id == 4){
                var persenBatasBawahGadaiEmas = Number(this.emasInput.BATAS_BAWAH_GADAI_EMAS).toFixed(2);
                this.emasInput.BATAS_BAWAH_GADAI_EMAS = persenBatasBawahGadaiEmas;
            }else if(id == 5){
                var persenAdmEmas = Number(this.emasInput.ADM_EMAS).toFixed(2);
                this.emasInput.ADM_EMAS = persenAdmEmas;
            }else if(id == 6){
                var persenDendaEmas = Number(this.emasInput.DENDA_EMAS).toFixed(2);
                this.emasInput.DENDA_EMAS = persenDendaEmas;
            }else if(id == 7){
                var persenBakuPerusahaan = Number(this.emasInput.BAKU_PERUSAHAAN_EMAS).toFixed(2);
                this.emasInput.BAKU_PERUSAHAAN_EMAS = persenBakuPerusahaan;
            }else if(id == 8){
                var potonganPengaitEmas = Number(this.emasInput.POTONGAN_PENGAIT_EMAS).toFixed(2);
                this.emasInput.POTONGAN_PENGAIT_EMAS = potonganPengaitEmas;
            }
        }
    },
    created(){
    }
}
</script>
